import * as React from "react";
import PropTypes from 'prop-types';

const SvgStoreFastTruck = props => {
  if (props.id !== "_svgstorefasttruck") {
    throw new Error('SVG requires <Icon> component as a parent, e.g. <Icon><SvgLogo></Icon>');
  }

  return <svg viewBox="0 0 65 38" {...props}><g fill="none" fillRule="evenodd" transform="translate(.333 .667)"><rect width={16.024} height={3} x={3.562} y={7.056} fill="#202020" fillRule="nonzero" rx={1.5} /><rect width={21.363} height={3} y={14.112} fill="#202020" fillRule="nonzero" rx={1.5} /><rect width={10.683} height={3} x={7.121} y={21.168} fill="#202020" fillRule="nonzero" rx={1.5} /><path stroke="#202020" strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M12.462 1.764h33.825v14.087h12.48l3.544 3.528v10.609H55.19" /><path stroke="#202020" strokeWidth={3} d="M46.287 5.292h8.808l3.562 10.584" /><ellipse cx={49.848} cy={29.988} stroke="#202020" strokeWidth={3} rx={5.341} ry={5.292} /><ellipse cx={23.145} cy={29.988} stroke="#202020" strokeWidth={3} rx={5.341} ry={5.292} /><path stroke="#202020" strokeWidth={3} d="M44.507 29.988H28.488" /><rect width={7.121} height={3} x={10.683} y={28.224} fill="#202020" fillRule="nonzero" rx={1.5} /></g></svg>;
};

SvgStoreFastTruck.displayName = "_svgstorefasttruck";
SvgStoreFastTruck.propTypes = {
  id: PropTypes.string
};
SvgStoreFastTruck.defaultProps = {
  id: ''
};
export default SvgStoreFastTruck;